import { httpClient, reportAxios } from "ultis/axios";

/**api lấy log cuộc gọi inbound (mới) */
const getLogInboundCalls = (params) => {
  return reportAxios.get("/api/v1/reports/inbound-call/log", {
    params,
  });
};

/**api lấy các cuộc gọi inbound (cũ) */
const getListInboundCall = (params) => {
  return httpClient.get("/cloud-pbx/inbound-call", {
    params,
  });
};

const getCountListInboundCall = (params) => {
  return httpClient.get("/cloud-pbx/inbound-call/count", {
    params,
  });
};

const exportListInboundCall = (params) => {
  return httpClient.get("/cloud-pbx/inbound-call", {
    params: {
      ...params,
      query: "export",
    },
  });
};

/**api lấy các đầu số của tổng đài*/
const getListNumberPbx = () => {
  return httpClient.get("/cloud-pbx/number");
};

const getReportCallMeDingdong = (params) => {
  return httpClient.get("/cloud-pbx/report-call-me-dingdong", {
    params,
  });
};

export const InboundApi = {
  getLogInboundCalls,
  getListInboundCall,
  getCountListInboundCall,
  exportListInboundCall,
  getListNumberPbx,
  getReportCallMeDingdong,
};
